import type { CSSProperties, ReactNode } from "react";
import { useEmbedTokens } from "../theme";
import type { TokenSet } from "../tokens";

type Tone = "default" | "secondary" | "error";

interface Props {
  tone?: Tone;
  size?: keyof TokenSet["fontSize"];
  children: ReactNode;
}

// Inline body copy with a token-driven tone + size.
export function EmbedText({ tone = "default", size = "sm", children }: Props) {
  const t = useEmbedTokens();
  const byTone: Record<Tone, string> = {
    default: t.colors.text,
    secondary: t.colors.textSecondary,
    error: t.colors.error,
  };
  const style: CSSProperties = {
    color: byTone[tone],
    fontSize: t.fontSize[size],
    lineHeight: t.lineHeight.normal,
  };
  return <span style={style}>{children}</span>;
}
